import { Bell_SVG } from '../../@icons/svg/Bell_SVG';
import * as Styled from './HeaderStyled';
import { useHeaderButtons } from './HeaderButtonProvider';
import { useDispatch, useSelector } from 'react-redux';
import { clearLoginUserData } from '../../store/modules/loginUserData';
import { useLocation, useNavigate } from 'react-router-dom';
import { RootState } from '../../store/modules';
import { useEffect, useRef, useState } from 'react';
import { UserInfo } from '../userHeader/UserInfo';
import Tooltip from '../tooltip/Tooltip';
import { categoryMap, HeaderDataType } from '../../@const/headerData';
import {
  setCustombarOpen,
  toggleCustombar,
} from '../../store/modules/customBar';
import { IoMdClipboard } from 'react-icons/io';
import styled from 'styled-components';
import { setOpen } from '../../store/modules/inquiriesState';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const inquiriesRef = useRef<Window | null>(null);

  const [headerData, setHeaderData] = useState<HeaderDataType>({
    categoryFirst: '',
    categorySecond: '',
    description: '',
  });

  // 현재 경로에서 root 제외하고, '/'를 붙여서 출력
  const currentPath = '/' + location.pathname.split('/').slice(1).join('/');
  // 공유게시판을 배송페이지에서만 사용 가능하도록 임시 설정하기위한 변수
  const [showBoard, setShowBoard] = useState<boolean>(false);
  const dispatch = useDispatch();
  const { buttons } = useHeaderButtons();
  const openHeader = useSelector((state: RootState) => state.header.open);

  useEffect(() => {
    if (!currentPath) return;
    const headerData = categoryMap[currentPath] as HeaderDataType;
    setHeaderData(headerData);
    if (currentPath === '/delivery/set' || currentPath === '/delivery/list') {
      setShowBoard(true);
      dispatch(setCustombarOpen(true));
    } else {
      setShowBoard(false);
      dispatch(setCustombarOpen(false));
    }
  }, [currentPath]);

  return (
    <Styled.Container open={openHeader}>
      <Styled.HeaderTop>
        <Styled.NavHistory>
          <div className='category-first'>
            {headerData && headerData.categoryFirst}
          </div>
          <div>&nbsp;/&nbsp;</div>
          {/* <div className='category-second'>Object Storage</div>
          <div>&nbsp;/&nbsp;</div> */}
          <div className='category-third'>
            {headerData && headerData.categorySecond}
          </div>
        </Styled.NavHistory>
        <Styled.InfoButtonSec>
          {/* <CustomText onClick={() => dispatch(setOpen(true))}>
            문의하기
          </CustomText> */}
          {headerData && headerData.helpDescription && (
            <Tooltip
              placement='left-start'
              iconSize={22}
              mode='text'
              customText='페이지 도움말'
            >
              {headerData.helpDescription}
            </Tooltip>
          )}
          <UserInfo />
          {showBoard && (
            <IoMdClipboard
              size={20}
              style={{ marginLeft: '5px', cursor: 'pointer' }}
              onClick={() => dispatch(toggleCustombar())}
            />
            // <div
            //   style={{
            //     marginLeft: '10px',
            //     cursor: 'pointer',
            //     textDecoration: 'underline',
            //     textUnderlineOffset: '4px',
            //     fontSize: '14px',
            //   }}
            // onClick={() => dispatch(toggleCustombar())}
            // >
            //   공유게시판
            // </div>
          )}
        </Styled.InfoButtonSec>
      </Styled.HeaderTop>
      <Styled.HeaderTitle>
        {headerData && headerData.description}
      </Styled.HeaderTitle>
      {buttons && <Styled.HeaderButtonSec>{buttons}</Styled.HeaderButtonSec>}
    </Styled.Container>
  );
};

export default Header;

const CustomText = styled.div`
  margin-top: 0;
  margin-bottom: 0;
  text-align: center;
  align-content: center;
  text-decoration: underline;
  margin-right: 10px;
  cursor: pointer;
`;
